import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40bd61cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检查组织：", -1));
const _hoisted_2 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检查成员：", -1));
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  style: {
    "font-size": "12px",
    "color": "#333333"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_timeline_item = _resolveComponent("el-timeline-item");
  const _component_el_timeline = _resolveComponent("el-timeline");
  return $data.reports && $data.reports.length > 0 ? (_openBlock(), _createBlock(_component_el_timeline, {
    key: 0
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.reports, (rp, rpIndex) => {
      return _openBlock(), _createBlock(_component_el_timeline_item, {
        key: rp.id,
        onClick: $event => $options.selectReport(rpIndex),
        color: rp.problemCnt > 0 ? '#F53F3F' : '#1677FE'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "checkItem"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(rp.createdTime.substring(0, 20)) + " " + _toDisplayString(rp.weekday), 1), _createElementVNode("div", {
            class: _normalizeClass(rpIndex == $data.selectedIndex ? 'checkInfo problem' : 'checkInfo')
          }, [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_hoisted_1, _createElementVNode("span", _hoisted_2, _toDisplayString(rp.signUserOrgName), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_row, {
            class: "checkMembers"
          }, {
            default: _withCtx(() => [_hoisted_3, _createElementVNode("img", {
              src: rp.signUserAvatar,
              style: {
                "width": "20px",
                "height": "20px",
                "border-radius": "4px"
              }
            }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString(rp.signUserName), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_tag, {
              class: _normalizeClass(rp.problemCnt > 0 ? 'dangerTag' : 'infoTag')
            }, {
              default: _withCtx(() => [_createTextVNode("问题项：" + _toDisplayString(rp.problemCnt), 1)]),
              _: 2
            }, 1032, ["class"]), rp.hiddenDangerCnt > 0 ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              class: "warningTag"
            }, {
              default: _withCtx(() => [_createTextVNode("隐患")]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)], 2)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["onClick", "color"]);
    }), 128))]),
    _: 1
  })) : _createCommentVNode("", true);
}